/** The URL parameter the inquiry form reads through a hidden field of the same name. */
export const VEHICLE_INQUIRY_PARAM = 'fahrzeug';

/** The mobile action bar appears once this marker below the aside's buttons has scrolled away. */
export const VEHICLE_CTA_SENTINEL_ID = 'vehicle-cta-sentinel';

/** Anchor of the financing section, linked from the price block. */
export const VEHICLE_FINANCING_ID = 'finanzierung';
